import SaveButton, { SaveButtonTemplate } from './SaveButton';

export default SaveButton;
export { SaveButtonTemplate };
